import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-domain-members',
  templateUrl: './domain-members.component.html',
  styleUrls: ['./domain-members.component.scss']
})
export class DomainMembersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
